var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSingleBtnDialogFlag)?_c('SingleBtnDialog',{attrs:{"messageType":_vm.singleBtnMsgType,"onClickConfirmBtn":_vm.onClickConfirmBtn}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }